import Vue from 'vue'

const state = {
    current_created_type: '',
    data: {},
    ref: {},
    selected_id: 0,
}
const mutations = {
	add (state, payload) {
		Vue.set(state.data, [payload.id], payload)
	},
	set (state, payload) {
		// state.data[payload.id] = payload
		Vue.set(state.data, [payload.id], payload)
	},
	remove (state, payload) {
		delete state.data[payload.id]
	},
	set_selected (state, id) {
		if (state.selected_id == id) {
			state.selected_id = ''
		} else {
            state.selected_id = id
        }
    },
    set_current_created_type (state, type) {
		state.current_created_type = type
	}
}
const getters = {
    list: (state) => {
        return Object.values(state.data)
            .filter((tag) => {
                if (tag.created_type == state.current_created_type) return true
            })
            .sort((a, b) => {
                return (Number(a.model_index) > Number(b.model_index) ? 1 : -1)
			})
    },
    selected_tag: (state) => {
        if (state.selected_id == '') {
            return {
                created_type: state.current_created_type,
                jp: '',
				en: '',
				model_index: 100,
				ios_icon: '',
				web_icon: '',
				sepcial_domains: [],
				sepcial_keywords: [],
            }
		} else {
            return state.data[state.selected_id]
        }
    },
    is_model: (state) => {
        return state.current_created_type == 'model' ? true : false
    },
    is_model_or_popular: (state) => {
        return (state.current_created_type == 'model' || state.current_created_type == 'popular') ? true : false
	},
	is_popular: (state) => {
        return state.current_created_type == 'popular' ? true : false
    },
}

const actions = {
	init ({ state, rootState }) {
		state.ref = rootState.db.collection('tags')
	},
	// 1. リスナーの起動
	startListener ({ commit, state }) {
		if (this.tagsUnsubscribe) {
			console.warn('listener is running. ', this.tagsUnsubscribe)
			this.tagsUnsubscribe()
			this.tagsUnsubscribe = null
		}
		// 3. Firestoreからデータを検索する
		const ref = state.ref
		this.tagsUnsubscribe = ref.onSnapshot(querySnapshot => {
			// 6. データが更新されるたびに呼び出される
			querySnapshot.docChanges().forEach(change => {
				// console.log('OnSnapshot tag', change.doc)

				const payload = {
                    id: change.doc.id,
                    created_type: change.doc.data().created_type,
					jp: change.doc.data().jp,
					en: change.doc.data().en,
					model_index: change.doc.data().model_index,
                    ios_icon: change.doc.data().ios_icon,
                    web_icon: change.doc.data().web_icon,
                    sepcial_domains: change.doc.data().sepcial_domains,
					sepcial_keywords: change.doc.data().sepcial_keywords,
					highly_recommeded: change.doc.data().highly_recommeded,
				}

				// 4. ミューテーションを通してステートを更新する
				if (change.type === 'added') {
					commit('add', payload)
				} else if (change.type === 'modified') {
					commit('set', payload)
				} else if (change.type === 'removed') {
					commit('remove', payload)
				}
			})
		},
		(error) => {
			console.error(error)
		})
	},
	// 8. リスナーの停止
	stopListener () {
		if (this.tagsUnsubscribe) {
			console.log('listener is stopping. ', this.tagsUnsubscribe)
			this.tagsUnsubscribe()
			this.tagsUnsubscribe = null
		}
    },
    new ({ state }, body) {
        const ref = state.ref
        const payload = to_shaped_tag(body)
        console.log('payload', payload)
		ref.add(payload)
		.then(doc => {
			console.log('new', doc)
		})
		.catch(err => {
			console.error('Error adding document: ', err)
		})
    },
    update ({ state }, body) {
        const ref = state.ref
        const payload = body
        ref.doc(payload.id).update(payload)
        .then(doc => {
            console.log('updated', doc)
        })
        .catch(err => {
            console.error('Error update type', err)
        })
	},
	update_highly_recommeded ({ state }, body) {
        const ref = state.ref
        ref.doc(body.id).update({ highly_recommeded: body.highly_recommeded})
        .then(doc => {
            console.log('updated', doc)
        })
        .catch(err => {
            console.error('Error update type', err)
        })
	},
}
function to_shaped_tag(body) {
    let shaped_tag = {
        created_type: body.created_type,
        jp: body.jp,
        en: body.en,
        used_count: 0,
        createdAt: new Date().getTime(),
        updatedAt: new Date().getTime(),
    }
	switch (shaped_tag.created_type) {
        case 'model', 'popular':
            shaped_tag.sepcial_keywords = body.sepcial_keywords
            shaped_tag.sepcial_domains = body.sepcial_domains
            break;
        case 'model':
            shaped_tag.model_index = body.model_index
            shaped_tag.ios_icon = body.ios_icon
            shaped_tag.web_icon = body.web_icon
			break;
		case 'popular':
            shaped_tag.highly_recommeded = body.highly_recommeded
            break;
		default:
			break;
    }

    return shaped_tag
}
export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions
}
